import { render, staticRenderFns } from "./partition.vue?vue&type=template&id=35a6c1ed&scoped=true&"
import script from "./partition.vue?vue&type=script&lang=js&"
export * from "./partition.vue?vue&type=script&lang=js&"
import style0 from "./partition.vue?vue&type=style&index=0&id=35a6c1ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a6c1ed",
  null
  
)

export default component.exports